// extracted by mini-css-extract-plugin
export default {"container":"TCPFooter_container__v9ViJ"};